/* eslint-disable @typescript-eslint/no-explicit-any */
import { color } from 'asserts/styles/colors';
import { usePercentagesFromArray } from './usePercentagesFromArray';

const useAddDataInBarChart = (type?: string) => {
  const getAddDataInBarChart = (chart: any) => {
    const {
      ctx,
      data,
      chartArea: { bottom },
      scales: { x }
    } = chart;

    chart.data.datasets.forEach((dataset: any, datasetIndex: number) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      meta.data.forEach((datapoint: any, index: number) => {
        const peopleCount: number = data.datasets[0].data[index] ?? 0;

        const getPercentagesFromArray = usePercentagesFromArray();

        const dataPercentages = getPercentagesFromArray(dataset.data)[index] ?? 0;

        const isValidPercentage = !isNaN(dataPercentages) && isFinite(dataPercentages);
        const rateCount = isValidPercentage ? ` ${dataPercentages.toFixed(1)}%` : ' N/A';

        const isReverse = chart.scales.x._reversePixels;

        ctx.save();
        ctx.font = '13px Noto Sans KR';
        ctx.fillStyle = `${color.white08}`;
        ctx.textBaseLine = 'middle';

        if (type === 'rom') {
          ctx.textAlign = 'left';
        } else if (type === 'romTwoChart') {
          ctx.textAlign = isReverse ? 'right' : 'left';
        } else {
          ctx.textAlign = 'center';
        }

        const sumText = `${peopleCount?.toLocaleString()}명`;

        const textWidth = ctx.measureText(sumText).width;

        if (type === 'rom') {
          ctx.fillText(`${sumText}`, 0, datapoint.y + 21);

          ctx.beginPath();
          ctx.font = '500 13px Noto Sans KR';
          ctx.fillStyle = `${color.white}`;

          ctx.fillText(`${rateCount}`, textWidth * 1.1, datapoint.y + 21);
        } else if (type === 'romTwoChart') {
          ctx.fillText(`${sumText}`, x.getPixelForValue(index), datapoint.y + 20);

          ctx.beginPath();
          ctx.font = '500 13px Noto Sans KR';
          ctx.fillStyle = `${color.white}`;

          const xPosition = isReverse
            ? x.getPixelForValue(index) - textWidth * 1.1
            : x.getPixelForValue(index) + textWidth * 1.1;

          ctx.fillText(`${rateCount}`, xPosition, datapoint.y + 20);
        } else {
          const sumText = `${peopleCount?.toLocaleString()}명`;

          ctx.fillText(`${sumText}`, x.getPixelForValue(index), bottom + 50);

          ctx.beginPath();
          ctx.font = '500 13px Noto Sans KR';
          ctx.fillStyle = `${color.white}`;
          ctx.fillText(`${rateCount}`, x.getPixelForValue(index) - 1, bottom + 65);
        }
      });
    });
  };

  return getAddDataInBarChart;
};

export default useAddDataInBarChart;
